export default "__VITE_ASSET__BcFB4ax7__"